export class GetMyGroupInvitationsAction {
  static readonly type = '[GroupInvitations] Get My Invitations';
}

export class AcceptGroupInvitationAction {
  static readonly type = '[GroupInvitations] Accept Invitation';
  constructor(public groupId: string) {}
}

export class DeclineGroupInvitationAction {
  static readonly type = '[GroupInvitations] Decline Invitation';
  constructor(public groupId: string) {}
}

export class RemoveGroupFromInvitationsAction {
  static readonly type = '[GroupInvitations] Remove From List';
  constructor(public groupId: string) {}
}

